import { defineStore } from 'pinia';
import _ from 'lodash';

import { License, type Organization, OrganizationFlags } from '../models';

export const useOrganizationStore = defineStore('organization', {
    state: () => ({
        currentOrganizationPath: null as Organization[] | null,
        organizationFlags: 0,
        licenses: [] as License[],
        callback: null as (() => void) | null
    }),
    actions: {
        setCurrentOrganizationPath(path: Organization[], licenses: License[]): void {
            this.currentOrganizationPath = _.cloneDeep(path);
            if (this.currentOrganization) {
                this.organizationFlags = 0;
                if (this.currentOrganization.clientAdmin) {
                    this.organizationFlags |= OrganizationFlags.ADMIN_CLIENT;
                }
                else {
                    this.organizationFlags |= OrganizationFlags.HAS_SHARED;
                }
                if (this.currentOrganization.topLevel) {
                    this.organizationFlags |= OrganizationFlags.TOP_LEVEL;
                }
                if (this.currentOrganization.publisher) {
                    this.organizationFlags |= OrganizationFlags.PUBLISHER;
                }
                if (this.currentOrganization.publisherAudio) {
                    this.organizationFlags |= OrganizationFlags.PUBLISHER_AUDIO;
                }
                if (this.currentOrganization.publisherVideo) {
                    this.organizationFlags |= OrganizationFlags.PUBLISHER_VIDEO;
                }
                if (this.currentOrganization.vaultEnabled) {
                    this.organizationFlags |= OrganizationFlags.VAULT_ENABLED;
                }
                if (this.currentOrganization.childrenCount) {
                    this.organizationFlags |= OrganizationFlags.HAS_CHILDREN;
                }
                this.licenses = [...licenses];
                if (this.callback) {
                    this.callback();
                }
            }
        },
        clearCurrentOrganizationPath(): void {
            this.currentOrganizationPath = null;
            this.organizationFlags = 0;
            this.licenses = [];
            this.callback = null;
        },
        checkOrganizationFlags(flags: number): boolean {
            return (flags & this.organizationFlags) === flags;
        },
        checkLicenses(licenses: License[]): boolean {
            return this.licenses.some(license => licenses.includes(license));
        }
    },
    getters: {
        currentOrganization: (state): Organization | undefined => state.currentOrganizationPath?.[state.currentOrganizationPath.length - 1],
        parentsIds: (state): number[] => state.currentOrganizationPath?.slice(0, -1).map(organization => organization.id) ?? []
    }
});